import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ToastMessageOptions } from 'primeng/api';
import { TaskListRefreshService } from '../../services/task-list-refresh.service';

const SEVERITY_ICONS: Record<string, string> = {
  success: 'pi pi-check-circle',
  error: 'pi pi-times-circle',
  warn: 'pi pi-exclamation-triangle',
  info: 'pi pi-info-circle',
};

@Component({
  selector: 'app-toasts',
  imports: [ToastModule],
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastsComponent {
  private router = inject(Router);
  private taskListRefresh = inject(TaskListRefreshService);

  getIconClass(msg: ToastMessageOptions): string {
    return msg.icon ?? SEVERITY_ICONS[msg.severity ?? ''] ?? SEVERITY_ICONS['info'];
  }

  onToastClick(message: ToastMessageOptions): void {
    const commands = message.data?.commands as string[] | undefined;
    if (!commands) return;

    const queryParams = message.data?.queryParams as Record<string, string> | undefined;
    const urlTree = this.router.createUrlTree(commands, queryParams ? { queryParams } : undefined);

    if (this.router.serializeUrl(urlTree) === this.router.url) {
      // Same URL the router would otherwise silently ignore (onSameUrlNavigation
      // defaults to 'ignore') — e.g. a generic task-list toast while already on
      // /tasks. Explicitly ask the active list to refresh instead.
      this.taskListRefresh.requestRefresh();
      return;
    }
    this.router.navigateByUrl(urlTree);
  }
}
